import dayjs from "dayjs";

const MARGIN_X = 40;

export const buildPoemFooterText = ({ trialName, visitName, siteId, participantId, visitDate }) => {
  const formattedVisitDate =
    visitDate && dayjs(visitDate).isValid()
      ? dayjs(visitDate).format("DDMMMYYYY").toUpperCase()
      : "-";
  return `Trial: ${trialName || "-"}    Visit: ${visitName || "-"}    SiteID-SubjectsID: ${
    siteId || "-"
  }-${participantId || "-"}    Visit Date: ${formattedVisitDate}`;
};

export const renderPoemSurveysToPdf = (pdf, { surveyList, footerText }) => {
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const contentWidth = pageWidth - MARGIN_X * 2;
  const footerY = pageHeight - 24;
  let y = 40;

  const addFooter = () => {
    pdf.setFont(undefined, "bold");
    pdf.setFontSize(9);
    pdf.text(footerText, pageWidth / 2, footerY, { align: "center" });
  };

  const ensureSpace = (needed) => {
    if (y + needed > footerY - 10) {
      addFooter();
      pdf.addPage();
      y = 40;
    }
  };

  surveyList.forEach((survey) => {
    ensureSpace(24);
    pdf.setFont(undefined, "bold");
    pdf.setFontSize(12);
    pdf.text(survey.survey_name || "", MARGIN_X, y);
    y += 6;
    pdf.setDrawColor(200);
    pdf.line(MARGIN_X, y, MARGIN_X + contentWidth, y);
    y += 16;

    survey.answers.forEach((question, index) => {
      pdf.setFont(undefined, "bold");
      pdf.setFontSize(10);
      const questionLines = pdf.splitTextToSize(
        `${index + 1}. ${question?.question || ""}`,
        contentWidth
      );
      ensureSpace(questionLines.length * 12 + 30);
      pdf.text(questionLines, MARGIN_X, y);
      y += questionLines.length * 12 + 6;

      const answerText = question?.is_multi_choice
        ? question?.answer?.map((a) => a?.choice).join(", ") || "-"
        : question?.answer || "-";
      pdf.setFont(undefined, "normal");
      pdf.setFontSize(9);
      const answerLines = pdf.splitTextToSize(String(answerText), contentWidth - 16);
      const boxHeight = Math.max(18, answerLines.length * 11 + 8);
      ensureSpace(boxHeight + 10);
      pdf.setDrawColor(180);
      pdf.setFillColor(245, 246, 250);
      pdf.rect(MARGIN_X, y, contentWidth, boxHeight, "FD");
      pdf.text(answerLines, MARGIN_X + 8, y + 12);
      y += boxHeight + 6;

      if (question?.extra_text) {
        const extraIndent = 16;
        const extraBoxWidth = contentWidth - extraIndent;

        pdf.setFont(undefined, "normal");
        pdf.setFontSize(9);
        const extraLines = pdf.splitTextToSize(String(question.extra_text), extraBoxWidth - 16);
        const extraBoxHeight = Math.max(18, extraLines.length * 11 + 8);
        ensureSpace(12 + extraBoxHeight + 6);

        // Text is drawn at its baseline, so most of a plain y-increment here gets eaten by the
        // label's own ascent -- needs roughly double the gap used elsewhere to read as the same
        // visible whitespace as the label-to-box gap below it.
        y += 6;
        pdf.setFont(undefined, "bold");
        pdf.setFontSize(8);
        pdf.text("Extra Text", MARGIN_X + extraIndent, y);
        y += 6;

        pdf.setFont(undefined, "normal");
        pdf.setFontSize(9);
        pdf.setDrawColor(180);
        pdf.setFillColor(245, 246, 250);
        pdf.rect(MARGIN_X + extraIndent, y, extraBoxWidth, extraBoxHeight, "FD");
        pdf.text(extraLines, MARGIN_X + extraIndent + 8, y + 12);
        y += extraBoxHeight + 6;
      }

      y += 12;
    });

    y += 8;
  });

  addFooter();
};
